module.exports = {
    resources: {
        gender: {
          name: 'Φύλο'
        },
        age: {
          name: 'Ηλικία'
        },
        man_system: {
            name: 'Management system'
        },
        general_admin: {
            name: 'General Administrator'
        },
        admins: {
            name: 'Διαχειριστές'
        },
        users: {
            name: 'Χρήστες'
        },
        companies: {
            name: 'Εταιρεία'
        },
        branches: {
            name: 'Υποκατάστημα'
        },
        product: {
            name: 'Προϊόν / Υπηρεσία'
        },
        oximata: {
            name: 'Όχημα'
        },
        complaint: {
            name: 'Όλα τα σχόλια'
        },
        survey: {
            name: 'Έρευνες'
        },
        questions: {
            name: 'Ερωτήσεις'
        },
        answers: {
            name: 'Απαντήσεις'
        },
        news: {
            name: 'Νέα / Προσφορές'
        },
        comments: {
            name: 'Σχόλια'
        },
        configuration: {
            name: 'Configuration'
        },
        configuration: {
            name: 'Ρυθμίσεις'
        },
        language: {
            name: 'Γλώσσα'
        },
        edit: {
            name: 'Επεξεργασία'
        },
        name: {
            name: 'ονομα'
        },
        surname: {
            name: 'επωνυμο'
        },
        management_admins: {
            name: 'Διαχείριση admins'
        },
        management_users: {
            name: "Διαχείριση χρηστών"
          },
        management_product: {
            name: 'Διαχείριση Προϊόντος/Υπηρεσίας'
        },
        management_branch: {
            name: 'Διαχείριση Υποκαταστήματος'
        },
        management_offers: {
            name: 'Διαχείριση για Νέα / Προσφορές'
        },
        management_companies: {
            name: ' Διαχείριση Εταιρειών'
        },
        offer_end: {
            name: 'Ημερομηνία λήξης'
        },
        number_of_votes: {
            name: 'ΑΡΙΘΜΟΣ ΨΗΦΟΦΟΡΩΝ'
        },
        percentage: {
            name: 'ΠΟΣΟΣΤΟ'
        },
        department: {
            name: 'Department'
        },
        management_comments: {
            name: 'Διαχείριση σχολίων'
        },
        password: {
            name: 'Κωδικος'
        },
        pay_quiz: {
            name: 'Πληρωμη για Quiz box'
        },
        image: {
            name: 'εικονα'
        },
        type: {
            name: 'Tύπος'
        },
        branch_address: {
            name: 'Διευθυνση υποκαταστηματος'
        },
        department: {
            name: 'Τμημα'
        },
        address: {
            name: 'Διέυθυνση'
        },
        change_pass: {
            name: 'Αλλαγή κωδικού'
        },
        new_pass: {
            name: 'Νέος κωδικός'
        },
        repeat_pass: {
            name: 'Επανάληψη κωδικού'
        },
        save: {
            name: 'Αποθήκευση'
        },
        pass_changed: {
            name: 'Ο κωδικός έχει αλλάξει.'
        },
        something_went_wrong: {
            name: 'Κάτι πηγε στραβά.'
        },
        pass_not_match: {
            name: 'Οι κωδικοι δεν ταιριαζουν'
        },
        title: {
            name: 'Τιτλος'
        },
        category: {
            name: 'Κατηγορια'
        },
        description: {
            name: 'Περιγραφη'
        },
        expiration_date: {
            name: 'ημερομ. ληξης προσφορας'
        },
        expiration_date: {
            name: 'ημερομ. ληξης προσφορας'
        },
        expiration_day: {
            name: 'Ημερομηνία λήξης'
        },
        start_day: {
            name: 'Ημερομηνια δημιουργιας'
        },
        participation: {
            name: 'Μέγ. αριθμός συμμετεχόντων'
        },
        answer_survey: {
            name: 'Απαντήσεις έρευνας'
        },
        count_votes: {
            name: 'ΑΡΙΘΜΟΣ ΨΗΦΟΦΟΡΩΝ'
        },
        percentage: {
            name: 'ΠΟΣΟΣΤΟ'
        },
        search_params: {
            name: '  Αναζ. (Οχήματος, Υπαλλήλου ή Προϊόντος / Υπηρεσίας)'
        },
        type_of_commnet: {
            name: 'Τύπος σχολιου'
        },
        date: {
            name: 'date'
        },
        read: {
            name: 'Διαβάστηκε'
        },positive: {
                  name: 'Θετικό'
          },
          negative: {
                  name: 'Αρνητικό'
          }
    },
    aor: {
        action: {
            delete: 'Διαγραφή',
            show: 'Εμφάνιση',
            list: 'Λίστα',
            save: 'Αποθήκευση',
            create: 'Δημιουργία',
            edit: 'Επεξεργασία',
            cancel: 'Ακύρωση',
            refresh: 'Ανανέωση',
            add_filter: 'Προσθήκη φίλτρου',
            remove_filter: 'Διαγραφή φίλτρου',
            back: 'Επιστροφή'
        },
        boolean: {
            true: 'Ναι',
            false: 'Όχι',
        },
        page: {
            list: 'Λίστα των %{name}',
            edit: '%{name} #%{id}',
            show: '%{name} #%{id}',
            create: 'Δημιουργία %{name}',
            delete: 'Διαγραφή %{name} #%{id}',
            dashboard: 'Αρχική',
            not_found: 'Η σελίδα δεν υπάρχει',

        },
        input: {
            file: {
                upload_several: 'Εναποθέστε μερικά αρχεία για ανέβασμα, ή κάντε κλίκ για να επιλέξετε ένα.',
                upload_single: 'Εναποθέστε ένα αρχείο για ανέβασμα, ή κάντε κλίκ για να το επιλέξετε.',
            },
            image: {
                upload_several: 'Εναποθέστε μερικές εικόνες για ανέβασμα, ή κάντε κλίκ για να επιλέξετε μία.',
                upload_single: 'Εναποθέστε μία εικόνα για ανέβασμα, ή κάντε κλίκ για να το επιλέξετε.',
            },
        },
        message: {
            yes: 'Ναι',
            no: 'Όχι',
            are_you_sure: 'Είστε σίγουρος;',
            about: 'Σχετικά',
            not_found: 'Είτε πληκτρολογήσατε λάθος URL, είτε ακολουθήσατε λάθος σύνδεσμο',
        },
        navigation: {
            no_results: 'Δεν βρέθηκαν αποτελέσματα',
            page_out_of_boundaries: 'Η σελίδα με αριθμό %{page} είναι εκτός ορίων',
            page_out_from_end: 'Δεν είναι δυνατή η περιήγηση μετά την τελευταία σελίδα',
            page_out_from_begin: 'Δεν είναι δυνατή η περιήγηση πριν την 1η σελίδα',
            page_range_info: '%{offsetBegin}-%{offsetEnd} από %{total}',
            next: 'Επόμενη',
            prev: 'Προηγούμενη',
        },
        auth: {
            username: 'Όνομα χρήστη',
            password: 'Κωδικός χρήστη',
            sign_in: 'Είσοδος',
            sign_in_error: 'Η ταυτοποίηση απέτυχε, προσπαθήστε ξανά',
            logout: 'Έξοδος',
        },
        notification: {
            updated: 'Η εγγραφή ανανεώθηκε',
            created: 'Η εγγραφή δημιουργήθηκε',
            deleted: 'Η εγγραφή διαγράφηκε',
            item_doesnt_exist: 'Η εγγραφή δεν υπάρχει',
            http_error: 'Σφάλμα επικοινωνίας με τον διακομιστή',
        },
        validation: {
            required: 'Υποχρεωτικό',
            minLength: 'Χρειάζονται τουλάχιστον %{min} χαρακτήρες',
            maxLength: 'Χρειάζονται το πολύ %{max} χαρακτήρες',
            minValue: 'Χρειάζονται τουλάχιστον %{min}',
            maxValue: 'Χρειάζονται το πολύ %{max} ή λιγότερο',
            number: 'Πρέπει να είναι αριθμός',
            email: 'Πρέπει να είναι έγκυρο email',
        },
    }
};



// WEBPACK FOOTER //
// ./src/translate/greekMessages.js